<div *ngIf="!initializing" class="flex justify-content-between flex-wrap py-3 card" [ngClass]="getColorCard()">
    <div class="flex align-items-center justify-content-start font-semibold border-round m-2">{{ description }}</div>
    <div class="flex align-items-center justify-content-end">
        <p-button *ngIf="canReconfigure()" label="{{ 'RETRY_INIT' | translate }}"
            (click)="retryInit()" [rounded]="false" [text]="true" severity="warning" styleClass="font-semibold">
        </p-button>
    </div>
</div>
<div *ngIf="initializing" class="card flex flex-row align-items-center justify-content-between py-3" [ngClass]="getColorCard()">
    <div class="font-semibold pr-2 m-2">{{ description }}</div>
    <p-progressBar mode="indeterminate" [style]="{'height': '6px', 'width': '10rem'}" />
</div>
